module.exports = __webpack_public_path__ + "static/media/profile.facfbd38.jpg";